
import { LineItemMarkupTier } from '@/types/line-item-markup-tiers';
import { usePricingPreview, PricingPreview } from './usePricingPreview';
import { usePricingUpdate } from './usePricingUpdate';

interface UsePricingRefreshProps {
  lineItemId: string;
  currentBaseCost: number;
  categoryId?: string;
  companyId?: string;
  customTiers?: LineItemMarkupTier[];
  useCustomTiers?: boolean;
}

export const usePricingRefresh = ({
  lineItemId,
  currentBaseCost,
  categoryId,
  companyId,
  customTiers = [],
  useCustomTiers = false
}: UsePricingRefreshProps) => {
  const {
    pricingPreview,
    showPricingPreview,
    closePricingPreview,
    hasChanges
  } = usePricingPreview({
    lineItemId,
    currentBaseCost,
    categoryId,
    companyId,
    customTiers,
    useCustomTiers
  });

  const { isRefreshing, updatePricing } = usePricingUpdate({ lineItemId });

  const refreshPricing = async (changeTrigger: string = 'manual_refresh'): Promise<boolean> => {
    const preview = await showPricingPreview();
    if (!preview) {
      throw new Error('Failed to generate pricing preview');
    }

    const success = await updatePricing(preview, changeTrigger);
    if (success) {
      closePricingPreview();
    }
    return success;
  };

  return {
    isRefreshing,
    pricingPreview,
    refreshPricing,
    showPricingPreview,
    closePricingPreview,
    hasChanges
  };
};

// Re-export the PricingPreview type for backward compatibility
export type { PricingPreview } from './usePricingPreview';
